export { default as cave, ReactComponent as Cave } from '@assets/icons/cave.svg'
